import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoObjChsM(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.84407 3.84425C9.05346 2.57296 10.3193 1.76421 11.5609 2.10849L12.366 2.33174C12.6321 2.40553 12.9076 2.24963 12.9814 1.98353C13.0552 1.71743 12.8993 1.4419 12.6332 1.36811L11.8281 1.14485C10.0135 0.641668 8.16339 1.8237 7.85736 3.68174L7.31084 6.99992L4.49993 6.99992C4.22379 6.99992 3.99993 7.22378 3.99993 7.49992C3.99993 7.77607 4.22379 7.99992 4.49993 7.99992L7.14613 7.99992L6.62178 11.1835C6.37823 12.6622 4.74297 13.4531 3.43257 12.7258L2.74222 12.3427C2.50077 12.2087 2.19641 12.2959 2.06241 12.5373C1.92842 12.7788 2.01553 13.0831 2.25698 13.2171L2.94732 13.6002C4.86252 14.6631 7.25252 13.5072 7.60849 11.346L8.15961 7.99992H10.4999C10.7761 7.99992 10.9999 7.77607 10.9999 7.49992C10.9999 7.22378 10.7761 6.99992 10.4999 6.99992H8.32431L8.84407 3.84425Z"
        fill="var(--color-typo-primary)"
      />
    </svg>
  )
}
export const IconGeoObjChs = createIcon({
  l: IconGeoObjChsM,
  m: IconGeoObjChsM,
  s: IconGeoObjChsM,
  xs: IconGeoObjChsM,
  name: 'IconGeoObjChs',
})
